export default __webpack_public_path__ + "static/media/hero-banner-webapplication.bb000ae7.png";